import { DymLiquidStakeMetaData, isSelectedCoinMinimalDenom } from '@/wallet-utils'
import { MsgLiquidStakeSDKType as DymMsgLiquidStake } from 'stridejs/dist/types/codegen/stride/stakedym/tx'
import { MetaDataFactoryParameters } from './types'
import { CHAIN_INFO_LIST } from '@/config'
import { assert } from '@/utils'

const createDymLiquidStakeMetaData = ({ response, message, denom }: MetaDataFactoryParameters<DymMsgLiquidStake>) => {
  const minimalDenom = CHAIN_INFO_LIST[denom].stakeCurrency.coinMinimalDenom

  assert(isSelectedCoinMinimalDenom(minimalDenom), `Invalid minimal denom ${minimalDenom} for denom ${denom}`)

  const meta: DymLiquidStakeMetaData = {
    type: 'dym-liquid-stake',
    values: {
      hash: response.txhash,
      // Let's add a new property called stakedAmount so we're much more accurate
      // instead of trying to calculate it using the current redemption rate which
      // may be different than when the actual stake occurred.
      amount: message.native_amount,
      // We are hard-coding this so we don't have to write type-guards.
      // @TODO In the future, maybe on v2, let's remove this as we don't seem to need this to be strictly typed.
      // This assumes that all of the transactions are from Stride
      denom,
      // We are hard-coding this so we don't have to write type-guards.
      // @TODO In the future, maybe on v2, let's remove this as we don't seem to need this to be strictly typed.
      // This assumes that all of the transactions are from Stride
      minimalDenom
    }
  }

  return meta
}

export { createDymLiquidStakeMetaData }
